import { Workbook } from 'exceljs'
import { CitizenCategory, IssuanceCardsStat, cardIssuePointGetAddress, citizenCategoryShorthand } from '@prodcard/core'
import { map, mapValues, size, sum, toArray } from 'lodash'

export function createSheetIssuanceCardsStats(
  workbook: Workbook,
  sheetName: string,
  opts: { groupedByCIP: IssuanceCardsStat[]; groupedByME: IssuanceCardsStat[] },
) {
  const worksheet = workbook.addWorksheet(sheetName)

  worksheet.columns = [
    { header: 'Муниципальное образование', width: 40 },
    { header: 'Пункт выдачи карт', key: 'salePoint', width: 40 },
    ...map(CitizenCategory, cc => ({ header: citizenCategoryShorthand(cc) })),
  ]

  const sumByCategory: Record<CitizenCategory, number> = mapValues(CitizenCategory, () => 0)

  opts.groupedByME.forEach(itemME => {
    worksheet.addRow([
      itemME.municipalEntity.name,
      '',
      ...map(CitizenCategory, cc => {
        sumByCategory[cc] += itemME.values[cc]
        return itemME.values[cc]
      }),
    ])

    opts.groupedByCIP
      .filter(i => i.municipalEntity.id === itemME.municipalEntity.id)
      .forEach(itemCIP => {
        worksheet.addRow([
          '',
          cardIssuePointGetAddress(itemCIP.cardIssuePoint) +
            (itemCIP.cardIssuePoint.comment ? ` (${itemCIP.cardIssuePoint.comment})` : ''),
          ...map(CitizenCategory, cc => itemCIP.values[cc]),
        ])
      })
  })

  if (opts.groupedByME.length > 1)
    worksheet.addRow(['Итого по категориям:', '', ...map(CitizenCategory, cc => sumByCategory[cc])])
  worksheet.addRow(['Общий итог:', '', ...new Array(size(CitizenCategory) - 1), sum(toArray(sumByCategory))])
}
